import { useMutation } from '@tanstack/react-query';
import { giveAskStanleyFeedback } from '@/lib/api/askStanley';

interface GenerateFeedbackParams {
    responseId: string;
    feedbackValue: 1 | -1;
}

export function useGenerateFeedbackMutation() {
    return useMutation({
        mutationFn: async ({ responseId, feedbackValue }: GenerateFeedbackParams) => {
            await giveAskStanleyFeedback(responseId, feedbackValue);
        },
    });
}
